<template>
  <div class="practice-game-wrapper">
    <games-player :game="game"/>
  </div>
</template>

<script>
import GamesPlayer from './games_player'

export default {
  props: {
    game: {
      type: Object,
      required: true
    }
  },

  components: {
    GamesPlayer
  }
}
</script>
